import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaComisionistas', {
    template: template,
    controller: NominaComisionistasComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
    },
  })

function NominaComisionistasComponent(NominaComisionistas) {
  let $ctrl = this,
    colores = [
      '#F44336',
      '#FF9800',
      '#FFEB3B',
      '#8BC34A',
      '#009688',
      '#2196F3',
      '#673AB7',
      '#9C27B0',
      '#E91E63',
      '#3F51B5',
    ]

  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.promise = NominaComisionistas.get($ctrl.idProyecto, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.data = response.data.map(function (item, index) {
          item.color = colores[index]
          return item
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/comisionistas/component.js